import { useMemo } from 'react';
import { OrderListItem } from '@shared/model/order';
import { orderStatusTag } from '@entities/order/libs/utils/order-status-tag/order-status-tag';
import { Tag } from '@shared/ui/tag/tag';
import { dateStart } from '@shared/lib/utils/date/date';
import { productPrice } from '@shared/lib/utils/product-price/product-price';

export const useCommonData = ({ orderData }: { orderData?: OrderListItem }) => {
    return useMemo(() => {
        if (orderData) {
            const tag = orderData?.status && orderStatusTag({ order: orderData, manager: orderData?.company?.manager });
            const amount = orderData?.requests
                ?.map((request) => request?.quantity)
                ?.reduce((acc, current) => acc + current, 0);

            const inn = orderData?.company?.inn && `ИНН ${orderData?.company?.inn}`;
            const kpp = orderData?.company?.kpp && `КПП ${orderData?.company?.kpp}`;

            return [
                {
                    label: 'Статус сделки',
                    content: (
                        <>
                            {tag && (
                                <Tag
                                    variant={tag.variant}
                                    declineMessage={
                                        {
                                            managerAvatarUrl: tag?.declineMessage?.managerAvatarUrl || '',
                                            managerName: tag?.declineMessage?.managerName || '',
                                            message: tag?.declineMessage?.message || '',
                                        } || undefined
                                    }>
                                    {tag.text}
                                </Tag>
                            )}
                        </>
                    ),
                    id: 1,
                    isFullWidth: false,
                },
                {
                    label: 'Дата создания сделки',
                    content: dateStart(orderData?.createdAt),
                    id: 2,
                    isFullWidth: false,
                },
                {
                    label: 'Стоимость',
                    content: productPrice({
                        price: Number(orderData.product.price) * (orderData.requests?.[0].quantity || 1),
                        withoutPrice: orderData.product.isPriceUndefined,
                    }),
                    id: 3,
                    isFullWidth: false,
                },
                {
                    label: 'Кол-во купленного продукта',
                    content: amount ? amount : '-',
                    id: 4,
                    isFullWidth: false,
                },
                {
                    label: 'Название организации',
                    content: orderData?.company?.shortName,
                    id: 5,
                    isFullWidth: true,
                },
                {
                    label: 'Реквизиты организации',
                    content: kpp ? `${inn}, ${kpp}` : `${inn}`,
                    id: 6,
                    isFullWidth: true,
                },
            ];
        }

        return [];
    }, [orderData]);
};

export const useBankDetails = ({ orderData }: { orderData?: OrderListItem }) => {
    return useMemo(() => {
        if (orderData) {
            return [
                {
                    label: 'Наименование банка',
                    content: orderData?.bankName,
                    id: 1,
                },
                {
                    label: 'Расчетный счет',
                    content: orderData?.bankAccountNumber,
                    id: 2,
                },
                {
                    label: 'Корр. счет',
                    content: orderData?.correspondentNumber,
                    id: 3,
                },
                {
                    label: 'БИК',
                    content: orderData?.bik,
                    id: 4,
                },
            ];
        }

        return [];
    }, [orderData]);
};
